module.exports = __webpack_public_path__ + "media/bootstrap-icons/emoji-dizzy-fill-fb8209c9.svg";